import { render, staticRenderFns } from "./value-input.vue?vue&type=template&id=3fce0e7b&scoped=true&"
import script from "./value-input.vue?vue&type=script&lang=js&"
export * from "./value-input.vue?vue&type=script&lang=js&"
import style0 from "./value-input.vue?vue&type=style&index=0&id=3fce0e7b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fce0e7b",
  null
  
)

export default component.exports